function ManageExperience() {
  return (
    <div className="block">
      <header className="block__head">
        <h2 className="h2">Experience</h2>
        <span className="muted">Manage the Experience page content.</span>
      </header>
    </div>
  )
}

export default ManageExperience
